import { render, staticRenderFns } from "./SalesContact.vue?vue&type=template&id=e795e8b4&scoped=true"
import script from "./SalesContact.vue?vue&type=script&lang=js"
export * from "./SalesContact.vue?vue&type=script&lang=js"
import style0 from "./SalesContact.vue?vue&type=style&index=0&id=e795e8b4&prod&lang=scss"
import style1 from "./SalesContact.vue?vue&type=style&index=1&id=e795e8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e795e8b4",
  null
  
)

export default component.exports